import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ContainerState } from './types';

export const initialState: ContainerState = {
  myautoiqNurturingJourneySettings: { data: null, loading: false, error: null },
};

const myautoiqNurturingJourneySettingsSlice = createSlice({
  name: 'myautoiqNurturingJourneySettingsComponentState',
  initialState,
  reducers: {
    requestMyautoiqNurturingJourneySettings(state, _action: PayloadAction<any>) {
      state.myautoiqNurturingJourneySettings.loading = true;
      state.myautoiqNurturingJourneySettings.error = null;
    },
    requestMyautoiqNurturingJourneySettingsSuccess(state, action: PayloadAction<any>) {
      state.myautoiqNurturingJourneySettings.data = action.payload;
      state.myautoiqNurturingJourneySettings.loading = false;
    },
    requestMyautoiqNurturingJourneySettingsError(state, action: PayloadAction<any>) {
      state.myautoiqNurturingJourneySettings.error = action.payload;
      state.myautoiqNurturingJourneySettings.loading = false;
    },
  },
});

export const {
  actions: myautoiqNurturingJourneySettingsActions,
  reducer,
  name: sliceKey,
} = myautoiqNurturingJourneySettingsSlice;
